module.exports = __webpack_public_path__ + "img/message_5.43bf4d9f.png";